import { render, staticRenderFns } from "./Help.vue?vue&type=template&id=3999f8ee"
import script from "./Help.vue?vue&type=script&lang=js"
export * from "./Help.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3999f8ee')) {
      api.createRecord('3999f8ee', component.options)
    } else {
      api.reload('3999f8ee', component.options)
    }
    module.hot.accept("./Help.vue?vue&type=template&id=3999f8ee", function () {
      api.rerender('3999f8ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/emc/info/Help.vue"
export default component.exports